var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "signup full__video noBoxShadow" }, [
    _vm._m(0),
    _vm._m(1),
    _c("div", { staticClass: "signup__form" }, [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.errorModal,
              expression: "errorModal"
            }
          ],
          staticClass: "message error"
        },
        [
          _c("p", [_vm._v(_vm._s(_vm.newUserError))]),
          _c("a", {
            staticClass: "close",
            on: {
              click: function($event) {
                _vm.errorModal = false
              }
            }
          })
        ]
      ),
      _c(
        "form",
        {
          attrs: { name: "registrationForm" },
          on: {
            submit: function($event) {
              $event.preventDefault()
              _vm.registerUser(_vm.newUser)
            }
          }
        },
        [
          _c("div", { staticClass: "ui-input" }, [
            _c("h1", [_vm._v("Create an account to get started")]),
            _vm.redirectUrl
              ? _c("div", { staticClass: "message informational" }, [
                  _c("p", [
                    _vm._v(
                      "After login you will be redirected to the Flixel Store"
                    )
                  ])
                ])
              : _vm._e(),
            _c("p", [_vm._v("Username")]),
            _vm.userNameError
              ? _c("p", { staticClass: "small-type" }, [
                  _vm._v("Username can only contain letters, numbers and '_'")
                ])
              : _vm._e(),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.newUser.username,
                  expression: "newUser.username"
                }
              ],
              attrs: {
                type: "text",
                name: "username",
                placeholder: "Choose a username",
                required: "required"
              },
              domProps: { value: _vm.newUser.username },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.newUser, "username", $event.target.value)
                }
              }
            }),
            _c("p", [_vm._v("Email")]),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.newUser.email,
                  expression: "newUser.email"
                }
              ],
              attrs: {
                type: "text",
                name: "email",
                placeholder: "Your email",
                required: "required"
              },
              domProps: { value: _vm.newUser.email },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.newUser, "email", $event.target.value)
                }
              }
            }),
            _c("p", [_vm._v("Password")]),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.newUser.password,
                  expression: "newUser.password"
                }
              ],
              attrs: {
                type: "password",
                name: "password",
                placeholder: "Choose a password",
                required: "required"
              },
              domProps: { value: _vm.newUser.password },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.newUser, "password", $event.target.value)
                }
              }
            }),
            _c("div", { staticClass: "marketingConsent--container" }, [
              _c("label", { staticClass: "checkbox--container" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.newUser.marketing_consent,
                      expression: "newUser.marketing_consent"
                    }
                  ],
                  attrs: { type: "checkbox" },
                  domProps: {
                    checked: Array.isArray(_vm.newUser.marketing_consent)
                      ? _vm._i(_vm.newUser.marketing_consent, null) > -1
                      : _vm.newUser.marketing_consent
                  },
                  on: {
                    change: function($event) {
                      var $$a = _vm.newUser.marketing_consent,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            _vm.$set(
                              _vm.newUser,
                              "marketing_consent",
                              $$a.concat([$$v])
                            )
                        } else {
                          $$i > -1 &&
                            _vm.$set(
                              _vm.newUser,
                              "marketing_consent",
                              $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                            )
                        }
                      } else {
                        _vm.$set(_vm.newUser, "marketing_consent", $$c)
                      }
                    }
                  }
                }),
                _c("span", { staticClass: "checkmark" }),
                _c("p", [_vm._v("Marketing Consent")])
              ]),
              _vm._m(2)
            ]),
            _c(
              "button",
              {
                staticClass: "btn btn--purpleLight",
                attrs: { type: "submit" }
              },
              [_vm._v("Register")]
            ),
            _c(
              "p",
              [
                _c(
                  "router-link",
                  { staticClass: "link", attrs: { to: "/login/" } },
                  [_vm._v("Already have an account?")]
                )
              ],
              1
            )
          ])
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "fluid__video splash form__video--horizontal" },
      [
        _c("iframe", {
          attrs: {
            src: "https://media.flixel.com/cinemagraph/mv7tif44u6c1vm9e30cs",
            allow: "autoplay"
          }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "fluid__video splash form__video--vertical" },
      [
        _c("iframe", {
          attrs: {
            src:
              "https://media.flixel.com/cinemagraph/ab06d2jrwa3ppzhdym0h?hd=true",
            allow: "autoplay"
          }
        }),
        _c("div", { staticClass: "credit" }, [
          _c(
            "a",
            {
              attrs: {
                target: "_blank",
                href: "https://flixel.com/jimmycheung/"
              }
            },
            [_vm._v("Jimmy Cheung")]
          )
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "subtext" }, [
      _c("p", [
        _vm._v(
          "Flixel can send me product updates and offers via email. You can opt-out at any time."
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-17c846a0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17c846a0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/auth/Register.vue
// module id = null
// module chunks = 